import Component from '~/components/component';

export default class ContactBlock extends Component {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// src/js/components/contact-block/contact-block.js